import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {
  FiBold,
  FiItalic,
  FiUnderline,
  FiList,
  FiHash,
  FiCheckSquare,
  FiMessageSquare,
  FiCode,
  FiType
} = FiIcons;

const TextFormatMenu = ({ editor }) => {
  if (!editor) {
    return null;
  }

  const formatButtons = [
    {
      icon: FiBold,
      isActive: editor.isActive('bold'),
      onClick: () => editor.chain().focus().toggleBold().run(),
      title: 'Bold'
    },
    {
      icon: FiItalic,
      isActive: editor.isActive('italic'),
      onClick: () => editor.chain().focus().toggleItalic().run(),
      title: 'Italic'
    },
    {
      icon: FiUnderline,
      isActive: editor.isActive('underline'),
      onClick: () => editor.chain().focus().toggleUnderline().run(),
      title: 'Underline'
    },
    { type: 'divider' },
    {
      icon: FiType,
      isActive: editor.isActive('paragraph'),
      onClick: () => editor.chain().focus().setParagraph().run(),
      title: 'Paragraph'
    },
    {
      icon: FiHash,
      isActive: editor.isActive('heading', { level: 1 }),
      onClick: () => editor.chain().focus().toggleHeading({ level: 1 }).run(),
      title: 'Heading 1'
    },
    {
      icon: FiHash,
      isActive: editor.isActive('heading', { level: 2 }),
      onClick: () => editor.chain().focus().toggleHeading({ level: 2 }).run(),
      title: 'Heading 2',
      className: 'text-sm'
    },
    { type: 'divider' },
    {
      icon: FiList,
      isActive: editor.isActive('bulletList'),
      onClick: () => editor.chain().focus().toggleBulletList().run(),
      title: 'Bullet List'
    },
    {
      icon: FiList,
      isActive: editor.isActive('orderedList'),
      onClick: () => editor.chain().focus().toggleOrderedList().run(),
      title: 'Numbered List',
      className: 'text-sm'
    },
    {
      icon: FiCheckSquare,
      isActive: editor.isActive('taskList'),
      onClick: () => editor.chain().focus().toggleTaskList().run(),
      title: 'Task List'
    },
    { type: 'divider' },
    {
      icon: FiMessageSquare,
      isActive: editor.isActive('blockquote'),
      onClick: () => editor.chain().focus().toggleBlockquote().run(),
      title: 'Quote'
    },
    {
      icon: FiCode,
      isActive: editor.isActive('codeBlock'),
      onClick: () => editor.chain().focus().toggleCodeBlock().run(),
      title: 'Code Block'
    },
  ];

  return (
    <div className="flex items-center px-1 py-1">
      {formatButtons.map((button, index) => {
        if (button.type === 'divider') {
          return (
            <div key={`divider-${index}`} className="h-6 w-px bg-gray-200 mx-1"></div>
          );
        }
        
        return (
          <button
            key={`${button.title}-${index}`}
            onClick={(e) => {
              e.preventDefault();
              button.onClick();
            }}
            className={`p-1.5 rounded-md hover:bg-gray-100 ${
              button.isActive ? 'bg-blue-50 text-blue-600' : 'text-gray-700'
            }`}
            title={button.title}
          >
            <SafeIcon 
              icon={button.icon} 
              className={button.className || ''} 
            />
          </button>
        );
      })}
    </div>
  );
};

export default TextFormatMenu;